import AlertsContainer from '@shared/hooks/state/AlertsContainer';
import Alert from '../core/alertNotification/Alert';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface IAlertsLoaderProps {}

export default function AlertsLoader(props: IAlertsLoaderProps) {
    const alertsContainer = AlertsContainer.useContainer();

    return (
        <>
            {alertsContainer.error && <Alert severity="error" message={alertsContainer.error} />}
            {alertsContainer.success && <Alert severity="success" message={alertsContainer.success} />}
            {alertsContainer.warning && <Alert severity="warning" message={alertsContainer.warning} />}
        </>
    );
}
